// extracted by mini-css-extract-plugin
export default {"button":"TagsInputRemove_button__Z7yir"};